export default () => {
    const modal = document.querySelector('.js-jobs-modal');
    const toggles = document.querySelectorAll('.js-jobs-modal-toggle');
    const hideButton = document.querySelector('.js-jobs-modal-hide');
    const body = document.querySelector('body');

    if (!modal || !toggles.length) {
        return;
    }

    if (hideButton) {
        hideButton.addEventListener('click', () => {
            const CookieDate = new Date();
            CookieDate.setDate(CookieDate.getDate() + 1);
            document.cookie = `hidejobs=true;expires=${CookieDate.toUTCString()};`;

            const container = hideButton.closest('.js-jobs-modal-toggle-container');
            if (container) {
                container.classList.add('is-mobile-hidden');
            }
        });
    }

    Array.from(toggles).forEach((toggle) => {
        const container = toggle.closest('.js-jobs-modal-toggle-container');
        if (container
            && container.classList.contains('is-mobile-hidden')
            && !document.cookie.split(';')
                .some((item) => item.trim()
                    .indexOf('hidejobs=') === 0)) {
            container.classList.remove('is-mobile-hidden');
        }

        toggle.addEventListener('click', () => {
            if (toggle.getAttribute('aria-expanded') === 'true') {
                toggle.setAttribute('aria-expanded', 'false');
            } else {
                toggle.setAttribute('aria-expanded', 'true');
            }

            modal.classList.toggle('open');
            body.classList.toggle('scrolllock');
        });
    });
};
